
<template>
  <div class="bg-cream">
    <Nav color="blue" :init-banner-state="false"></Nav>
    <section id="tbwttnl" class="padding-main">
      <div>
         <div id="title-block" class="row mb-6 gap-3 space-between container-large">
          <div class="basis-65-gap-1">
            <img class="card" src="../../assets/img/landing-pages/tbwttnl/TBWTTNL_hero.png">
          </div>
          <div id="app-info-container" class="col basis-30-gap-3">
            <img id="icon-click" src="@/assets/img/landing-pages/ICON_app-click.png">
            <CompanionAppHighlight app-name="The Bear Chapters" class="border-blue" color="blue"></CompanionAppHighlight>
            <button class="blue full" @click="pushAppRedirect()">Download the app</button>
            <button class="outline blue full" @click="pushStorePageRedirect()">Purchase the game</button>
          </div>
        </div>
        <div class="container-large">
          <div id="submenu">
          <nav id="lp-submenu" class="mt-1 blue">
            <div class="clickable-link">
              <a href="#video-block" :class="{ active: activeSection === 'video-block' }">Trailer </a>
            </div>
            <div class="clickable-link">
              <a href="#tbwttnl-concept" :class="{ active: activeSection === 'tbwttnl-concept'}">How to play</a>
            </div>
            <div class="clickable-link">
              <a href="#cards" :class="{ active: activeSection === 'cards'}">Story Cards</a>
            </div>
            <div class="clickable-link">
              <a href="#abt-story" :class="{ active: activeSection === 'abt-story'}">About the story</a>
            </div>

            <!--            <a>Behind the scene</a>-->
          </nav>
        </div>
          <div id="video-block">
            <iframe allow="autoplay; fullscreen; picture-in-picture" allowfullscreen class="card aspect-16-9" src="https://player.vimeo.com/video/774860236?h=4416748c36&title=0&byline=0&portrait=0"></iframe>
          </div>
          <div id="benefits" class="grid grid-4">
            <div class="benefit-item blue">
              <img src="@/assets/img/landing-pages/tbwttnl/ICON_VARIATIONS.png">
              <p><strong>Up to 9</strong><br>story variations</p>
            </div>
            <div class="benefit-item blue">
              <img src="@/assets/img/landing-pages/tbwttnl/ICON_AR.png">
              <p><strong>Engaged</strong><br>screen time</p>
            </div>
            <div class="benefit-item blue">
              <img src="@/assets/img/landing-pages/tbwttnl/ICON_AGE_TBWTTNL.png">
              <p>Best for<br><strong>4 to 8 years old</strong></p>
            </div>
            <div class="benefit-item blue">
              <img src="@/assets/img/landing-pages/tbwttnl/ICON_CANADA.png">
              <p>Designed in<br><strong>Squamish, BC</strong></p>
            </div>

          </div>
          <TBWTTNLConcept></TBWTTNLConcept>
          <TBWTTNLCards></TBWTTNLCards>
          <div id="abt-story">
            <div class="card background-visual"></div>
            <!--          <img class="card" src="@/assets/img/landing-pages/tbwttnl/TBWTTNL_about-the-story.png">-->
            <div id="abt-story-block" class="card card-container bg-cream">
              <h2 class="blue">About the story</h2>
              <p>The story follows a bored little polar bear who notices the Northern Lights and makes it his mission to find a way to reach them and play with them. </p>
              <p>During his voyage, he travels a long way through various landscapes, makes new friends, and learns to live in the moment. </p>
              <p>When it comes down to it, the Frozen Lands’ highest mountain might not high enough to reach the Northern Lights, but worry not, he won’t be bummed very long! </p>
            </div>
          </div>
          <StoreFeaturedProducts class="mb-4"></StoreFeaturedProducts>
        </div>
      </div>
    </section>
    <SmallPreFooter></SmallPreFooter>
    <Footer :borderTop=false></Footer>
  </div>
</template>

<script>
import router from "@/router/index.js";
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";
import TBWTTNLConcept from "@/components/ProductSpecific/TBWTTNLConcept.vue";
import TBWTTNLCards from "@/components/ProductSpecific/TBWTTNLCards.vue";
import ProductLearnMore from "@/components/ProductLearnMore.vue";
import ProductThumbnail from "@/components/ProductThumbnail.vue";
import SmallPreFooter from "@/components/SmallPreFooter.vue";
import StoreFeaturedProducts from "@/components/StoreFeaturedProducts.vue";
import CompanionAppHighlight from "@/components/CompanionAppHighlight.vue";

export default {
  name: 'TheBearWhoTouchedTheNorthernLights',
  props: ['filter'],
  components: {
    CompanionAppHighlight,
    StoreFeaturedProducts,
    SmallPreFooter,
    ProductThumbnail,
    ProductLearnMore,
    TBWTTNLCards,
    TBWTTNLConcept,
    Footer,
    Nav
  },
  data () {
    return {
      anchorsToWatch: ["video-block", "tbwttnl-concept", "cards", "abt-story"],
      activeSection: null,
      observer: null,
    }
  },
  mounted() {
    this.createObserver();
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  computed: {
    products() {
      return this.$store.getters.getFeaturedProducts;
    }
  },
  methods: {
    pushStorePageRedirect() {
      router.push('/product/the-bear-who-touched-the-northern-lights')
    },
    pushAppRedirect() {
      router.push(this.$store.getters.getAppRedirectByName('The Bear Chapters'));
    },
    createObserver() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.5, // Adjust threshold as needed
      };

      this.observer = new IntersectionObserver(this.handleIntersect, options);

      this.anchorsToWatch.forEach((item) => {
        const el = document.getElementById(item);
        if (el) {
          this.observer.observe(el);
        }
      });

    },
    handleIntersect(entries) {

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeSection = entry.target.id;
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables";

#tbwttnl {
  position: relative;
}
#title-block {

  .basis-65-gap-1 {
    flex-grow: 1;
  }

  h2 {
    font-weight: normal;
    font-size: 1.5em;
  }

  #icon-click {
    max-width: 240px;
  }

  #product-shot-hero {
    height: auto;
    max-width: 230px;

    img {
      border-radius: 40px;
    }

  }

  #product-text-block {
    margin-left: 200px;
    margin-top: -120px;

    h1 {
      font-size: 3em;
      padding-bottom: 0.1em;
    }
  }

  button {
    margin: 0 0 1em 0;
    //width: 80%;
  }

}

#app-info-container {
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  max-width: 500px;
}

#submenu {
  z-index: 10;
  border-top: 1px solid $blue;
  padding-bottom: 1em;
  margin-bottom: 3em;
  position: sticky;
  top: 0;
  background-color: $cream;
}

nav#lp-submenu {
  display: inline-flex;

  .clickable-link {
    margin-right: 3em;

    a {
      margin: 0;
      padding: 0.6em 0.2em 0.6em 0;
    }
  }
}

#video-block {
  iframe {
    width: 100%;
  }
}

#tbwttnl-concept {
  &.card-container {
    margin: 0 0 6em 0;
  }
}

#abt-story {
  margin-top: 6em;
  margin-bottom: 0em;

  .background-visual {
    min-height: 800px;
    width: 100%;
    background-image: url("../../assets/img/landing-pages/tbwttnl/TBWTTNL_about-the-story.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

}

#abt-story-block {
  position: relative;
  z-index: 4;
  background-color: $cream;
  margin: -14em 0px 0px 5% ;
  max-width: 40%;
}


@media only screen and (max-width: 1200px) {
  #title-block {
    justify-content: center;
    gap: 3em;

    .left {
      display: flex;
      flex-direction: row;
      flex-basis: fit-content;
    }

    #icon-click {
      max-width: 100px;
    }


    #product-text-block {
      margin-left: -2em;
      margin-top: 6em;
    }

    .right {
      flex-basis: fit-content;
    }

    #app-block {
      img.app-icon {
        max-width: 100px;
      }
    }
  }
}

@media only screen and (max-width: 747px) {

  nav#lp-submenu {
    display: flex;
    flex-direction: column;
  }

  #benefits {
    margin: 3em 0px 3em 0px;

    &.grid.grid-4 {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  #abt-story {
    .background-visual {
      min-height: 400px;
    }
  }

  #abt-story-block {
    border: 1px solid $blue;
    max-width: 100%;
    margin: -6em 0px 0px 0px;
  }

  #benefits .benefit-item {
    img {
       max-width: 60%;
    }
    p {
      font-size: 1.4em;
    }
  }

  #video-block iframe.card {
    border-radius: 20px;
  }

   #store-featured  {
     .grid.grid-3 {
      grid-template-columns: repeat(2, 1fr);
       gap: 1em;
    }
     #featured-products {
        width: 100%;
     }

  }
}

@media only screen and (min-width: 1440px) {
  #title-block {
    #product-shot-hero {
      height: auto;
      max-width: 250px;
      border-radius: 40px;
    }

    #product-text-block {
      margin-left: 220px;
      margin-top: -120px;

      h1 {
        font-size: 4em;
        padding-bottom: 0.1em;
      }
    }

    h2 {
      font-size: 1.8em;
    }
  }
}

</style>
